import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../index';
import { observer } from 'mobx-react-lite';
// DEV-89 (`oq-ММБ-121` (а)): тот же адрес, что у обработчика входа, — возврат на
// исходную страницу сильнее правила «по роли», и оба ведут в одно место.
import { postLoginTarget } from '../../utils/returnPath';
import './home.css';


export default observer(function Home() {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  // Редирект авторизованных: на исходную страницу (если человека застало
  // истечение сессии), иначе — страница по роли.
  useEffect(() => {
    if (store.isAuth && store.user?.role) {
      navigate(
        postLoginTarget(
          store.user.role,
          `${window.location.pathname}${window.location.search}`,
        ),
        { replace: true },
      );
    }
  }, [store.isAuth, store.user?.role]);

  if (store.isLoading) {
    return <div className="loadingLoginform">Загрузка...</div>;
  }

  if (!store.isAuth) {
    // DEV-81 (ФРН-Q1): форму входа выводит только Layout — он показывает её на
    // любой странице без входа. Второй <LoginForm /> здесь ложился на первую
    // (обе position: absolute), и «Забыли пароль?» переключал верхнюю: из-под неё
    // были видны «АВТОРИЗАЦИЯ» и «Войти» нижней.
    return null;
  }

  return null;
});
